import { ModalWindow } from '@/components/ModalWindow/ModalWindow';
import AlertSecondaryIcon from '@/images/AlertSecondaryIcon.svg?react';
import { COLORS } from '@/styles/colors';
import { Button } from '@/components/Button/Button';
import { Box } from '@/components/Box/Box';
import { EmailLink } from '@/components/EmailLink/EmailLink';
import { Typography } from '@/components/Typography/Typography';

type DocumentVerificationErrorModalType = {
  isOpen: boolean;
  email: string;
  onClose: () => void;
};

export const DocumentVerificationErrorModal = ({ isOpen, email, onClose }: DocumentVerificationErrorModalType) => {
  return (
    <ModalWindow isOpen={isOpen} width='504px'>
      <Box display='flex' flexDirection='column' rowGap='28px'>
        <Box display='flex' flexDirection='column' rowGap='20px' alignItems='center'>
          <AlertSecondaryIcon />
          <Box width='100%' display='flex' flexDirection='column' alignItems='center' rowGap='12px'>
            <Typography variant='headline4' color={COLORS.grey[950]} fontWeight='semibold'>
              ID Verification Failed
            </Typography>
            <Typography color={COLORS.grey[950]} textAlign='center'>
              Your ID verification failed. Please contact <EmailLink email={email} variant='big' /> or start
              verification again to provide wire info for this wire.
            </Typography>
          </Box>
        </Box>
        <Button onClick={onClose}>Close</Button>
      </Box>
    </ModalWindow>
  );
};
